import React from 'react'

export function useModal(initialState) {
    const [show, setShow] = React.useState(initialState)

    const open = React.useCallback(() => setShow(true),[])
    const close = React.useCallback(() => setShow(false),[])

    return [show, open, close]
}
export default useModal
